import { Getter, GetterTree } from 'vuex'

import { IProjectItem, IProjectItemsGetterResult, IProjectStore } from '@/features/projectList/store'
import { ALL_PROJECT_TYPES } from '@/constants'

import {
  GET_PROJECTS,
  GET_SELECTED_PROJECTS
} from '@/system/store/getter-types'

const getProjects: Getter<IProjectStore, any> = (state: IProjectStore): IProjectItemsGetterResult => {
  if (state.projects === undefined) {
    const errorObj: IProjectItemsGetterResult = []

    errorObj.$error = true
    errorObj.$errorReason = 'NO_PROJECTS_FOUND'

    return errorObj
  }

  let projectList = state.projects.items
  if (state.select && state.select !== ALL_PROJECT_TYPES.value) {
    projectList = projectList.filter(item => item.system === state.select)
  }
  if (state.search) {
    return projectList.filter(item => {
      if (item.nameByCustomer) return item.nameByCustomer.toLowerCase().indexOf(state.search) !== -1
      return item.nameByCustomer === null
    })
  }

  return projectList
}

const getSelectedProject: Getter<IProjectStore, any> = (state: IProjectStore) => {
  return state.selectedProjects
}

const getters: GetterTree<IProjectStore, any> = {
  [ GET_PROJECTS ]: getProjects,
  [ GET_SELECTED_PROJECTS ]: getSelectedProject
}

export default getters
